/*  ========================================================================
    # Scripts - Word Deco
    ========================================================================  */

/**
 * Script that applys a random deco svg in a given wrapper called "u-word-deco".
 */
const WordDeco = {
  cfg: {
    decoratives: window.decoSVGs
  },

  /**
   * Add random word deco to given node.
   */
  addWordDeco() {
    const observer = new IntersectionObserver(elements => {
      elements.forEach(element => {
        if (element.isIntersecting) {
          element.target.classList.add('u-word-deco--animate');
        }
      });
    });

    document.querySelectorAll('.u-word-deco').forEach(word => {
      // Observe word
      observer.observe(word);

      // Add random deco SVG to word.
      const decoNumber = Math.floor(Math.random() * Object.keys(this.cfg.decoratives).length);
      const decoSVG = Object.values(this.cfg.decoratives)[decoNumber];
      word.setAttribute('data-deco', decoNumber + 1);
      word.insertAdjacentHTML('beforeend', decoSVG);
    });
  },

  /**
   * Initialize.
   */
  init() {
    this.addWordDeco();
  }
};

export default WordDeco;
